import React from 'react';
import { useEffect, useState } from 'react';
import {ShowLocaleDateTime, loadPhoto } from '../../helpers/helpers';
import { Col } from 'antd';

export const Photos = ({measurerUUID, photo, onClick, onLoad}) => {

	const [ loaded, setLoaded ] = useState( false );
	const [ src, setSrc ] = useState( '' );

	useEffect(() => {
		let params = {
			uuid: measurerUUID,
			photo_id: photo.id			
		}
		loadPhoto( params )
        .then((data) => {
        	if (data.hasOwnProperty('file_source')) {
				onLoad( photo.id, data.file_source );
        		setSrc( data.file_source );
			}
        	setLoaded( true );
        });
	}, [measurerUUID, photo]);

	return (
		<div className="mb-2">						
			<div className="chart-window-photo">
				{loaded && 
					<span onClick={onClick}><img src={"data:image/png;base64, " + src} /></span>
				}
			</div>
			<div className="mt-1 b text-center">{ShowLocaleDateTime(photo.time)}</div>				
		</div>
	)
}